'use client';
import React, { ReactElement } from 'react';

import { Breadcrumb as PartnerBreadcrumb } from '@monetization/hpaip-components-library';
import { Header as VeneerHeader } from '@veneer/core';
import { t } from 'i18next';
import Image from 'next/image';

import { sendAnalytics } from '@storefront/app/analytics/SimpleTriggerEvent';
import {
  defaultURL,
  RequiredPartnerData,
} from '@storefront/app/pdp-config/shared-components/header/header';
import useGetPartnerCompensation from '@storefront/hooks/useGetPartnerCompensation';
import usePartner from '@storefront/hooks/usePartner';
import { uiEvents } from '@storefront/services/DataCollection/simpleUiEvents';
import { buildPath } from '@storefront/utils/utils';

import styles from './header.module.scss';

export interface HeaderProps {
  topRightArea?: ReactElement;
}

export default function Header({ topRightArea }: Readonly<HeaderProps>) {
  const { hpChannel } = usePartner();
  const { data, error } = useGetPartnerCompensation(hpChannel);
  const isValidPartner =
    !!hpChannel &&
    hpChannel.trim() !== '' &&
    !!data?.getPartnerCompensation?.hp_partner_name;

  const onClickHandler = async () => {
    const partnerUrl =
      data?.getPartnerCompensation?.hp_off_ramp_redirect_url ?? defaultURL;
    const partnerName =
      data?.getPartnerCompensation?.hp_partner_name ?? 'HpStore';
    await sendAnalytics({
      simpleUiEvent: uiEvents.breadcrumbEvent,
      override: {
        controlName: 'Partner',
        controlDetail: `partnerUrl=${partnerUrl}&name=${partnerName}`,
      },
    });
  };

  const brandingArea = isValidPartner ? (
    <div className={styles['partner-breadcrumb']}>
      <PartnerBreadcrumb
        partnerCompensation={{ data: data as RequiredPartnerData }}
        error={error}
        onClick={onClickHandler}
        defaultURL={defaultURL}
        clientReferrer={''}
      />
    </div>
  ) : (
    <Image
      src={buildPath('HPLogo-blue.svg')}
      width="48"
      height="48"
      alt={t('button.hpLogo')}
      priority
    />
  );

  return (
    <VeneerHeader
      leadingArea={brandingArea}
      trailingArea={topRightArea}
      position="sticky"
      className={styles.header}
    />
  );
}
